<div class="app-state-panel" role="status" [attr.data-testid]="testId">
  <mat-icon class="app-state-panel__icon" aria-hidden="true">{{
    icon
  }}</mat-icon>
  <p class="app-state-panel__title">{{ title }}</p>
  <p *ngIf="message" class="app-state-panel__message">{{ message }}</p>
  <button
    *ngIf="retryLabel"
    type="button"
    class="app-state-panel__retry"
    (click)="retry.emit()"
  >
    {{ retryLabel }}
  </button>
</div>
